/* eslint-disable */
/**
 * Neptune TP API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourseSummaryDto
 */
export interface CourseSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof CourseSummaryDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CourseSummaryDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CourseSummaryDto
     */
    fileSizeBytes: number;
    /**
     * 
     * @type {number}
     * @memberof CourseSummaryDto
     */
    version: number;
}

export function CourseSummaryDtoFromJSON(json: any): CourseSummaryDto {
    return {
        'id': json['id'],
        'name': json['name'],
        'fileSizeBytes': json['fileSizeBytes'],
        'version': json['version'],
    };
}

export function CourseSummaryDtoToJSON(value?: CourseSummaryDto | null): any {
    if (value == undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'name': value.name,
        'fileSizeBytes': value.fileSizeBytes,
        'version': value.version,
    };
}


